const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://mars2.mediacle.net';

export const fetchBrandsForKeywordGap = async () => {
  const response = await fetch(`${API_BASE_URL}/api/gap`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' }
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch brands — HTTP ${response.status}`);
  }

  return await response.json();
};

export const analyzeKeywordGap = async (brandUrl, competitorUrl, database = 'uk') => {
  const response = await fetch(`${API_BASE_URL}/api/keyword-gap/analyze`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ brandUrl, competitorUrl, database })
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
    throw new Error(errorData.message || `HTTP ${response.status}`);
  }

  return await response.json();
};

export const formatNumber = (num) => {
  if (num === null || num === undefined) return '—';
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
  return num.toLocaleString();
};
